module.exports = __webpack_public_path__ + "img/theMan.5c257f3a.png";